// extracted by mini-css-extract-plugin
module.exports = {"menu":"basic-menu_menu__q3mwF"};